import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Label, } from '@models';
import { LabelService, NotificationService } from '@services';
import { catchError, of } from 'rxjs';

export const labelResolver: ResolveFn<Label | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const service = inject(LabelService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }

  return service.read(id).pipe(
    catchError((err) => {
      console.error(err);

      router
        .navigate(['/404'], {
          skipLocationChange: true,
        })
        .finally(() => {
          notificationService.error('Failed to load the label.');
        });

      return of(null);
    }),
  );
};
